export const BACK_ARROW_CLICK = "Back Arrow Click";
export const BROWSER_NAVIGATION = "Browser Navigation";
export const CHAPTER_BUTTON = "Chapter Button";
export const CHAPTER_MENU_VIEWED = "Chapter Menu Viewed";
export const CHAPTER_MENU_CLOSED = "Chapter Menu Closed";
export const CHILD_CHAPTER_VIEWED = "Child Chapter Viewed";
export const FULLSCREEN = "Fullscreen";
export const PAUSE = "Pause";
export const PLAY = "Play";
export const QA_SCROLL = "QA Scroll";
export const QA_SUBMENU = "QA Submenu";
export const RETURN_TO_PARENT_CHAPTER = "Return To Parent Chapter";
export const SCRUB = "Scrub";
export const SLIDESHOW_ARROW_CLICK = "Slideshow Arrow Click";
export const SLIDESHOW_SWIPE = "Slideshow Swipe";
export const STORY_INFO_CHAPTER_CLICK = "Story Info Chapter Click";
export const STORY_INFO_CLOSED = "Story Info Closed";
export const STORY_INFO_VIEWED = "Story Info Viewed";
export const STORY_LIST_VIEWED = "Story List Viewed";
export const STORY_PREVIEW_CLICK = "Story Preview Click";
export const STORY_TITLE_CLICK = "Story Title Click";
export const TIMELINE_CAPTION_HIDE_CLICK = "Timeline Caption Hide Click";
export const TIMELINE_CAPTION_SHOW_CLICK = "Timeline Caption Show Click";
export const TIMELINE_HIDE_CLICK = "Timeline Hide Click";
export const TIMELINE_SHOW_CLICK = "Timeline Show Click";
export const TIMELINE_SLIDE_CLICK = "Timeline Slide Click";
export const VERSE_LOGO = "Verse Logo";
